import { queryOptions } from "@tanstack/react-query";
import type { GetOptions } from "@capacitor/preferences";

const preferencesModule =
	import.meta.env.VITE_CAPACITOR_BUILD === "true"
		? import("@capacitor/preferences")
		: null;

export function buildGetPreferencesQueryKey(options: GetOptions) {
	return ["capacitor-preferences-get", options];
}

export function buildGetPreferencesQuery(options: GetOptions) {
	return queryOptions({
		queryKey: buildGetPreferencesQueryKey(options),
		queryFn: () =>
			preferencesModule
				? preferencesModule.then((m) => m.Preferences.get(options))
				: Promise.reject(new Error("Preferences are not supported")),
		enabled: !!preferencesModule,
	});
}
